import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import common from './common';

export { useTranslation, Trans, I18nextProvider } from 'react-i18next';
export type { TFunction } from 'i18next';

i18next.use(initReactI18next).init({
  react: {
    useSuspense: false,
    transSupportBasicHtmlNodes: false,
    transWrapTextNodes: '',
  },
  lng: 'en',
  saveMissing: false,
  returnNull: false,
  defaultNS: 'common',
});

i18next.addResources('en', 'common', common);

export const getKey = (key: string, options: Record<string, unknown> = {}) =>
  i18next.t(key, options);

export const hasKey = (key: string) => i18next.exists(key);

export default i18next;
